import { formatCompactLength, formatCount } from "@/shared/utils/format";
import { i18n } from "@/shared/i18n";

/**
 * Business callback: axis-trigger tooltip for the paper-usage combo chart.
 * When a printed color is selected the bar is a stacked pair — two entries
 * share the series name "Printed Length", so the labels are derived from the
 * series order: [selected-color share, other colors, job count] (convention
 * section 40).
 */
export function paperUsageTooltip(params: unknown): string {
  const list = Array.isArray(params) ? params : [params];
  if (list.length === 0) return "";

  const header = (list[0] as { name?: string })?.name ?? "";
  const hasSplit = list.length > 2;
  // Tooltips render outside the React tree — read the active language
  // straight from the i18next instance.
  const t = i18n.t;

  const lines = list.map((item, index) => {
    const p = item as { seriesName?: string; value?: unknown };
    const value = typeof p.value === "number" ? p.value : Number(p.value ?? 0);
    // Bar entries are printed lengths; the last entry is the Job Count line.
    if (index < list.length - 1) {
      const label = hasSplit
        ? index === 0
          ? t("charts.tooltip.selectedColor")
          : t("charts.tooltip.otherColors")
        : t("charts.tooltip.printedLength");
      return `<div>${t("charts.tooltip.printedLength")}${hasSplit ? ` (${label})` : ""}: <strong>${formatCompactLength(value)}</strong></div>`;
    }
    return `<div>${p.seriesName ?? t("charts.tooltip.jobCount")}: <strong>${formatCount(value)}</strong></div>`;
  });

  return [`<div><strong>${t("charts.tooltip.paperWidth")}: ${header} inch</strong></div>`, ...lines].join("");
}
